// extracted by mini-css-extract-plugin
export default {"spinner_container":"spinner_spinner_container__W8Fgn","spinner":"spinner_spinner__uGy6D"};